/*
 * @Author: your name
 * @Date: 2020-09-16 17:58:08
 * @LastEditTime: 2021-04-13 08:39:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lzxy-homepage\lzxy-homepage\src\commons\menus.ts
 */
export const menuList = [
  { title: '首页', url: 'index.html' },
  // { title: '资讯', url: 'infoNews.html#' },
  // { title: '企业风采', url: 'featuresEnterprise.html' },
  { title: '我要学习', url: 'study.html#' },
  { title: '个人中心', url: 'learningPlan.html#' }
]

export const menuEnterpriseList = [
  { title: '首页', url: 'index.html' },
  { title: '资讯', url: 'infoNews.html#' },
  // { title: '企业风采', url: 'featuresEnterprise.html' },
  { title: '我要学习', url: 'study.html' },
  { title: '我要下单', url: 'createOrder.html#' },
  { title: '个人中心', url: 'home.html' }
]
